<template>
    <div class=" fixed z-10 inset-0 bg-next-light-gray">
        <div class="flex items-center justify-center h-screen p-4 overflow-y-auto">
            <div class="bg-white p-6 border-2 border-next-neu">
                <div class="flex justify-center m-8">
                    <img src="@/assets/Next_logo.svg" class="">
                </div>
                <div class="flex justify-center">
                    <div v-if="env.googleLoginEnabled">
                        <div class="flex flex-col items-center m-3 text-center text-2xl">
                            <div class="p-2">Google</div>
                            <a :href="googleUrl">
                                <i class="fab fa-google py-2 px-8 bg-next-orange text-white"></i>
                            </a>
                        </div>
                    </div>
                    <div class="">
                        <div class="flex flex-col items-center m-3 text-center text-2xl">
                            <div class="p-2">Microsoft</div>
                            <a :href="microsoftUrl">
                                <i class="fab fa-microsoft py-2 px-8 bg-next-orange text-white"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import {mapActions, mapGetters} from 'vuex';
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import env from '@/Environment'

@Options({
    name: 'Login',
    components: {},
    computed: {
        ...mapGetters([
            'isAuthenticated',
        ]),

    },
    methods: {
        ...mapActions([
            'fetchUser',
        ]),
    },
    props: {
        next_route: String,
    }
})
export default class Login extends Vue {
    isAuthenticated!: any;
    fetchUser!: any;
    next_route!: string;
    env = env

    @Watch('isAuthenticated')
    redirect_if_logged() {
        if (this.isAuthenticated) {
            //@ts-ignore
            this.$router.replace('/projects/')
        }
    }

    get googleUrl() {
        return `${env.backendUrl}/auth/google/redirect`
    }

    get microsoftUrl() {
        return `${env.backendUrl}/auth/microsoft/redirect`
    }

    created() {
        if(this.next_route){
            localStorage.setItem('next_route', this.next_route)
        } else{
            localStorage.removeItem('next_route')
        }
        // debugger
        // this.fetchUser()
    }
}

</script>


<style lang="scss">
.home {
    background-color: green;
}
</style>
